import script from "./KarlsruheLocality.vue?vue&type=script&lang=js"
export * from "./KarlsruheLocality.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__